//@flow

import { put, takeEvery } from 'redux-saga/effects';
import {
  LOAD_MODELS_DETAILS,
  DELETE_MODEL,
} from '../types/model';
import {
  loadModelsDetailsSuccess,
  loadModelsDetailsFail,
  deleteModelSuccess,
  deleteModelFails,
} from '../actions/model';
import { 
    getFlights
} from './../actions/flightManager';
import axios from 'axios';

export async function getModelsDetails(action: { axiosInstance: Object, id: Number }) {
  const { axiosInstance, id } = action;
  const url = `projects/${String(id)}/models`;
  const response = await axiosInstance.get(url);
  const { data } = response;
  return data;
}

export async function getThumbsDetails(modelUrl: string) {
  const uid = modelUrl.split('/')[4];
  var url = null;

  if (uid !== undefined){   
    const urlThumb = `https://api.sketchfab.com/v3/models/${uid}`;
    await axios.get(urlThumb)
      .then((response) => {
        const dataThumb = response.data.thumbnails;
        if (dataThumb === null) {
          url = null;
        } else if (dataThumb.images.length >= 4) {
          url = dataThumb.images[3].url;
        } else {
          url = dataThumb.images[0].url;
        };
      })
      .catch(() => { url = null; });
  }
  return url;
}

export function* loadModelsDetailsSaga(
  action: { axiosInstance: Object, projectId: Number }
): Generator<any, void, any> {
  try {
      const result = yield getModelsDetails(action);
      for (let element of result) {
        const resultUrl = yield getThumbsDetails(element.url);
        element['urlThumb'] = resultUrl;
      };
      yield put(loadModelsDetailsSuccess(result));  
  } catch (err) {
      yield put(loadModelsDetailsFail(err));
  }
};

export function* watchLoadModelsDetails(): Generator<any, void, any> {
  yield takeEvery(LOAD_MODELS_DETAILS, loadModelsDetailsSaga);
};

export function* deleteModelSaga(
  action: { axiosInstance: Object, modelId: Number }
): Generator<any, void, any> {
  try {
    const { axiosInstance } = action;
    yield axiosInstance.request(
      {
        url: `models/${String(action.modelId)}`,
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
        }
      }
    );
    yield put(getFlights(axiosInstance));
    yield put(deleteModelSuccess(action.modelId));
  }
  catch (error) {
    yield put(deleteModelFails(error));
  }
}

export function* watchDeleteModels(): Generator<any, void, any> {
  yield takeEvery(DELETE_MODEL, deleteModelSaga);
}


// WEBPACK FOOTER //
// ./src/sagas/model.jsx